import { client, getUrl } from "utils";

export const getObjectStructuresRequest = (filterParams) => client.get(getUrl("object-structures", filterParams));
